import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { Button, Checkbox, Divider, TextArea, TextField } from '@sbt-web/ui';
import { FormProps } from '../../types';
import { ConfirmMessage, ErrorDialog } from './components';
import { useContactForm } from './hooks/useContactForm';
import styles from './ProLeadForm.module.scss';
const INTEREST_OPTIONS = ['Permuta con la mia auto', 'Preventivo assicurazione', 'Opzioni di finanziamento', 'Dettagli garanzia', 'Trasporto a domicilio'];
export const ProLeadForm = props => {
  const $ = _c(53);
  const {
    advertiserName,
    item,
    userId
  } = props;
  const {
    buyerPhone,
    handleSetPhoneNumber,
    message,
    errors,
    setMessage,
    updateSelectedInterest,
    handleSubmit,
    replyDone,
    handleConfirmMessageCtaClick,
    sendAdreply,
    showErrorDialog,
    setShowErrorDialog
  } = useContactForm(props, "pro");
  let t0;
  if ($[0] !== replyDone) {
    t0 = cn(styles.form, {
      [styles.hide]: replyDone
    });
    $[0] = replyDone;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className={cn("headline-6", styles.hideMobile)}>Contatta il venditore</h2>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Divider spacing="null" classes={[styles.divider, styles.hideMobile]} />;
    t3 = <h3 className="caption bold">Cosa ti interessa?</h3>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== updateSelectedInterest) {
    t4 = INTEREST_OPTIONS.map(opt => <Checkbox name={opt} key={opt} onChange={isChecked => updateSelectedInterest(opt, isChecked)} value={opt} reverse={true}>{opt}</Checkbox>);
    $[5] = updateSelectedInterest;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className={styles.checkboxContainer}>{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== setMessage) {
    t6 = e => setMessage(e.target.value);
    $[9] = setMessage;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== message || $[12] !== t6) {
    t7 = <div className={styles.textAreaContainer}><TextArea name="message" placeholder="Altre domante? (opzionale)" value={message} onInputChange={t6} rows={3} /></div>;
    $[11] = message;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider spacing="null" classes={[styles.divider]} />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleSetPhoneNumber) {
    t9 = e_0 => handleSetPhoneNumber(e_0.target.value);
    $[15] = handleSetPhoneNumber;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      label: "Numero di telefono (consigliato)"
    };
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== buyerPhone || $[19] !== t9) {
    t11 = <TextField name="phone" type="tel" value={buyerPhone} onInputChange={t9} inputHeaderProps={t10} placeholder="348 99 09 009" />;
    $[18] = buyerPhone;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className={`body-text small ${styles.suggestion}`}>Riceverai una risposta più rapida</p>;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11) {
    t13 = <div>{t11}{t12}</div>;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Button classes={[styles.submitButton]}>Invia la richiesta</Button>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13) {
    t15 = <div className={styles.phoneAndSubmitContainer}>{t13}{t14}</div>;
    $[25] = t13;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== handleSubmit || $[28] !== t0 || $[29] !== t15 || $[30] !== t5 || $[31] !== t7) {
    t16 = <form className={t0} onSubmit={handleSubmit} method="POST">{t1}{t2}{t3}{t5}{t7}{t8}{t15}</form>;
    $[27] = handleSubmit;
    $[28] = t0;
    $[29] = t15;
    $[30] = t5;
    $[31] = t7;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== advertiserName || $[34] !== handleConfirmMessageCtaClick || $[35] !== item || $[36] !== replyDone) {
    t17 = replyDone && <ConfirmMessage advertiserName={advertiserName} isVisible={replyDone} categoryId={item.category.id} onClick={handleConfirmMessageCtaClick} />;
    $[33] = advertiserName;
    $[34] = handleConfirmMessageCtaClick;
    $[35] = item;
    $[36] = replyDone;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== setShowErrorDialog) {
    t18 = () => setShowErrorDialog(false);
    $[38] = setShowErrorDialog;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== sendAdreply || $[41] !== setShowErrorDialog || $[42] !== userId) {
    t19 = () => {
      setShowErrorDialog(false);
      sendAdreply(userId);
    };
    $[40] = sendAdreply;
    $[41] = setShowErrorDialog;
    $[42] = userId;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== errors || $[45] !== showErrorDialog || $[46] !== t18 || $[47] !== t19) {
    t20 = <ErrorDialog isOpened={showErrorDialog} onClose={t18} errors={errors} onRetry={t19} />;
    $[44] = errors;
    $[45] = showErrorDialog;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t16 || $[50] !== t17 || $[51] !== t20) {
    t21 = <div className={styles.formContainer}>{t16}{t17}{t20}</div>;
    $[49] = t16;
    $[50] = t17;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  return t21;
};